import { Button, Layout, Input } from "antd";
import { CustomModal } from "../common/CustomModal";
import * as React from "react";
import { Formik } from "formik";
import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { CustomSelect } from "../common/CustomSelect";
import { checkPermission } from "../AdminUser/CheckPremission";

const { Content } = Layout;

export class AddModule extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      selectedCourseType: "",
      errors: {
        selectedCourseType: "",
      },
    };
  }

  allCourses = [];

  async componentDidMount() {
    const { authToken, course_id } = this.props;

    let courseData = await listAllDropDownCourse(authToken, 0, 1000000);

    if (courseData.data && courseData.data.length >= 1) {
      courseData.data.forEach((data) => {
        this.allCourses.push({
          value: data._id,
          label: data.name,
        });
      });
    }

    if (course_id) {
      this.setState({
        selectedCourseType: course_id
      });
    }
  }

  validateForm = (values) => {
    const { selectedCourseType } = this.state;
    const errors = {};

    console.log("Validating form -- ", values);

    if (!values.name) {
      errors.name = "Name is required";
    }

    if (!selectedCourseType) {
      errors.selectedCourseType = "Please select course";
    }

    console.log("Validating errors -- ", errors);
    return errors;
  };

  handleSubmit = (values, action) => {
    const { selectedCourseType } = this.state;

    values.course_id = selectedCourseType;
    values.is_module = true;

    this.props.onSubmit(values);

    this.setState({
      visible: false,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false
    });
  };

  changeCourse = (value) => {
    this.setState({
      selectedCourseType: value,
    });
  };

  render() {
    const { primaryColor, course_id, logindata } = this.props;
    const { selectedCourseType } = this.state;
    const canAdd = checkPermission(logindata, "course", "create");

    return (
      <div>
        <div
          onClick={canAdd ? this.showModal : null}
          style={{
            width: "100px",
            backgroundColor: primaryColor,
            color: "white",
            padding: "7px 0px",
            textAlign: "center",
            borderRadius: "50px",
            cursor: canAdd ? "pointer" : "not-allowed",
            opacity: canAdd ? 1 : 0.5,
            pointerEvents: canAdd ? "auto" : "none",
          }}
        >
          ADD
        </div>

        <CustomModal
          destroyOnClose={true}
          title="Add Module"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          maskClosable={false}
          bodyStyle={{ minHeight: "350px" }}
        >
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                name: ""
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Name
                          <Input
                            id="name"
                            placeholder="Name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.name && touched.name ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.name}
                            </p>
                          ) : null}
                        </div>

                        <div className="formik-field-right">
                          Course
                          {course_id ?
                            <CustomSelect
                              style={{ width: "100%" }}
                              placeholder="Select Course"
                              disabled={true}
                              value={selectedCourseType}
                              options={this.allCourses}
                            />
                            :
                            <CustomSelect
                              style={{ width: "100%" }}
                              onChange={(value) => this.changeCourse(value)}
                              placeholder="Select Course"
                              showSearch={true}
                              value={selectedCourseType}
                              options={this.allCourses}
                            />
                          }
                          {errors.selectedCourseType ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.selectedCourseType}
                            </p>
                          ) : null}
                        </div>

                      </div>

                      <Button type="primary" style={{ marginTop: "19px", background: "#5C6AC4", color: "#fff", }} onClick={handleSubmit}>
                        Add
                      </Button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </CustomModal>
      </div>
    );
  }
}
